import { render, staticRenderFns } from "./GwView.vue?vue&type=template&id=115fa51b&scoped=true&"
import script from "./GwView.vue?vue&type=script&lang=js&"
export * from "./GwView.vue?vue&type=script&lang=js&"
import style0 from "./GwView.vue?vue&type=style&index=0&id=115fa51b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115fa51b",
  null
  
)

export default component.exports